import * as signalR from "@microsoft/signalr";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { selectAccessToken } from "../auth/authSlice";


// export default function Signalr(setSensorDataArray?: any) {
export default function useInOutHub({
    setInOutData,
}: {
    setInOutData?: (inCount: number, outCount: number) => void
}) {
    const locateStorageToken = localStorage.getItem('accessToken')
    const reduxStoreToken = useSelector(selectAccessToken)
    const accessToken = reduxStoreToken as string | null || locateStorageToken as string

    const connection = useRef<signalR.HubConnection>()

    useEffect(() => () => {
        if (connection != undefined) {
            (connection.current as signalR.HubConnection).stop()
        }
    }, [])

    const start = (workScheduleId: string) => {
        if (connection.current)
            return

        connection.current = new signalR.HubConnectionBuilder().withUrl(`${process.env.REACT_APP_BASE_URL}inOutHub`, { accessTokenFactory: () => accessToken }).build()
        // let _connection = new signalR.HubConnectionBuilder().withUrl(`${process.env.REACT_APP_BASE_URL}inOutHub`).build()
        var _connection = connection.current
        _connection.start().then(() => {
            _connection.invoke("SubscribeToInOutData", workScheduleId);
        }).catch((err: any) => {
            console.error(err.toString());
        });

        _connection.on("ReceiveInOutData", (inCount: number, outCount: number) => {
            setInOutData && setInOutData(inCount, outCount); // Update the data array or object
        })
    }

    return { start }
}